import { animated } from 'react-spring';
import { Box } from '../Box';

export const AnimatedBox = animated(Box);
